import { useEffect, useRef, useState } from 'react';
import { useLocale } from '@/i18n';
import { copperButton } from '@/shared/ui/game-theme';
import { browserSessionRequest, getBrowserCSRF, invalidateBrowserSession } from '../api/browser-session';

export function BrowserSignoutContainer() {
  const { locale } = useLocale();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const request = useRef<AbortController | null>(null);
  useEffect(() => () => request.current?.abort(), []);
  const csrfToken = getBrowserCSRF();
  if (!csrfToken) return null;
  const ru = locale === 'ru';
  const signout = async () => {
    if (request.current) return;
    const controller = new AbortController();
    request.current = controller;
    setBusy(true); setError(false);
    try {
      const value = await browserSessionRequest('logout', { csrfToken, signal: controller.signal });
      if (!controller.signal.aborted) {
        if (value.authenticated) throw new Error('Logout rejected');
        invalidateBrowserSession();
      }
    } catch {
      if (!controller.signal.aborted) setError(true);
    } finally {
      request.current = null;
      if (!controller.signal.aborted) setBusy(false);
    }
  };
  return <section style={{ marginTop: 20 }}>
    <button type="button" disabled={busy} style={{ ...copperButton, minHeight: 44, padding: '10px 16px' }} onClick={() => { void signout(); }}>
      {busy ? (ru ? 'Выходим…' : 'Signing out…') : (ru ? 'Выйти из аккаунта' : 'Sign out')}
    </button>
    {error && <p role="alert">{ru ? 'Не удалось выйти. Попробуйте ещё раз.' : 'Unable to sign out. Please try again.'}</p>}
  </section>;
}
